// Pure helpers for the Hero kickoff countdown. No React, no DOM — so they
// can be unit-tested under Node (Vitest) without jsdom.
//
// Phases:
//   pre   — now < kickoff. Show the ticking countdown.
//   live  — kickoff <= now < final + 24h grace. Show "TOURNAMENT LIVE".
//   post  — now >= final + 24h. Hide the strip entirely.
//
// ESM (named exports) because this module is imported from JSX bundled by
// Rollup, which does static analysis on imports.

export const WC26_KICKOFF_UTC = '2026-06-11T23:00:00Z'; // Mexico City opener, 18:00 CDT
export const WC26_FINAL_UTC   = '2026-07-19T23:00:00Z'; // Final, conservative UTC estimate

const POST_GRACE_MS = 24 * 3600 * 1000;

export function formatCountdown(targetISO, nowMs) {
  const target = Date.parse(targetISO);
  const finalMs = Date.parse(WC26_FINAL_UTC);

  if (nowMs >= finalMs + POST_GRACE_MS) {
    return { phase: 'post', days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
  if (nowMs >= target) {
    return { phase: 'live', days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  let remaining = Math.max(0, target - nowMs);
  const days    = Math.floor(remaining / 86400e3); remaining -= days * 86400e3;
  const hours   = Math.floor(remaining / 3600e3);  remaining -= hours * 3600e3;
  const minutes = Math.floor(remaining / 60e3);    remaining -= minutes * 60e3;
  const seconds = Math.floor(remaining / 1000);

  return { phase: 'pre', days, hours, minutes, seconds };
}
